import { getFileIcon } from "../../store/misc";
import { MdiReactIconProps } from "mdi-react";

const FileIcon: React.FC<{ contentType?: string | null } & MdiReactIconProps> = ({ contentType, ...iconProps }) => {
  const Comp = getFileIcon(contentType?.toLowerCase().split("/").pop());
  return <Comp {...iconProps} />;
};

export default FileIcon;
